export default __webpack_public_path__ + "static/media/appStore-JAP.87955099.png";